import script from "./SetPasswordPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SetPasswordPage.vue?vue&type=script&lang=ts&setup=true"

import "./SetPasswordPage.vue?vue&type=style&index=0&id=92b68dae&lang=scss&scoped=true"
script.__scopeId = "data-v-92b68dae"

export default script